import { ButtonText, Dialog, DialogCardBody, DialogCardFooter } from "@visa/vds";
import React from "react";

const DashboardActionItemsDialog = (props) => {
    return (
        <Dialog
            aria-labelledby="export-dialog"
            aria-describedby="export-dialog"
            onExit={() => props.setOpenDialog(false)}
            open={props.openDialog}
            type="warning"
            aria-label="custom warning"
            className="dialog-card"
        >
            <DialogCardBody className="dialog-card" id="dialog-description-example-3">
                {props.accordionHeaderActionComponent}
            </DialogCardBody>
            <DialogCardFooter>
                <ButtonText
                    className="width-full"
                    colorScheme="secondary"
                    onClick={() => props.setOpenDialog(false)}>
                    Cancel
                </ButtonText>
            </DialogCardFooter>
        </Dialog>
    )
}

export default DashboardActionItemsDialog;